module.exports = __webpack_public_path__ + "static/media/resume.80721b3e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/doc/resume.pdf
// module id = 164
// module chunks = 0